const initProductMedia = () => {
	const swiper = new Swiper('.swiper--product-media', {
		speed: 500,
		spaceBetween: 0,
		loop: false,
		slidesPerView: 1,
		pagination: {
			el: '.swiper-pagination--product-media',
			type: 'bullets',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-button-next--product-media',
			prevEl: '.swiper-button-prev--product-media',
		},
		init: false,
	});
	swiper.init();
	window.initImageLoad();
};
initProductMedia();

const getProductDataUS = () => {
	fetch(window.Shopify.routes.root + 'products/' + product_handle + '.js')
		.then(response => response.json())
		.then(data => {
			let productVariants = data.variants;
			let totalVariants = 0;
			let availableCount = 0;
			let stockThreshold = stock_threshold;
			for (let variant of productVariants) {
				if (variant.available) availableCount++;
				totalVariants++;
			}
			let currentStock = (availableCount / totalVariants) * 100;
			if (currentStock <= stockThreshold && totalVariants > 1) document.querySelector('.warning').textContent = label_low_stock;
		});
};

const getProductDataGB = function () {
	fetch(window.Shopify.routes.root + 'products/' + product_handle + '.js')
		.then(response => response.json())
		.then(data => {
			let productVariants = data.variants;
			let variant_count = 0;
			let variants_in_stock = 0;
			let total = 0;
			let xxs = undefined;
			let xs = undefined;
			let s = undefined;
			let m = undefined;
			let l = undefined;
			let xl = undefined;
			for (let variant of productVariants) {
				total += variant.inventory_quantity;
				variant_count += 1;
				if (variant.inventory_quantity > 0) variants_in_stock++;
				if (variant.option1 == 'XXS') xxs = variant.inventory_quantity;
				if (variant.option1 == 'XS') xs = variant.inventory_quantity;
				if (variant.option1 == 'S') s = variant.inventory_quantity;
				if (variant.option1 == 'M') m = variant.inventory_quantity;
				if (variant.option1 == 'L') l = variant.inventory_quantity;
				if (variant.option1 == 'XL') xl = variant.inventory_quantity;
			}
			if (variant_count < 2) {
				if (total < single_stock_threshold && total > 0) {
					console.log("WHY?", total, single_stock_threshold);
					document.querySelector('.warning').textContent = label_low_stock;
				}
			} else {
				let variant_stock_limit = Math.round((variant_count / 100) * variant_stock_threshold);
				if (total >= 1) {
					if (variants_in_stock < variant_stock_limit) {
						document.querySelector('.warning').textContent = label_low_stock;
					} else if (l !== undefined && l < large_stock_threshold) {
						document.querySelector('.warning').textContent = label_low_stock;
					} else if (l !== undefined && m < medium_stock_threshold) {
						document.querySelector('.warning').textContent = label_low_stock;
					} else if (variants_in_stock <= variant_stock_limit) {
						document.querySelector('.warning').textContent = label_low_stock;
					}
				}
			}
		});
};
if (product_region === 'us') {
	getProductDataUS();
} else {
	getProductDataGB();
}

const cloneUSPS = () => {
	const uspElement = document.querySelector('.tabs-header .usps');
	if (uspElement) {
		const clonedElement = uspElement.cloneNode(true);
		const uspTarget = document.getElementById('product-usps');
		if (uspTarget) uspTarget.appendChild(clonedElement);
		setTimeout(() => {
			window.initPopups();
		}, 500);
	}
};
cloneUSPS();

const initViewMore = () => {
	const viewMore = document.querySelector('.view-full');
	if (viewMore)
		viewMore.addEventListener('click', e => {
			e.preventDefault();
			const detailsEl = document.querySelector('.product-tabs');
			if (detailsEl) {
				const distanceToTop = window.scrollY + detailsEl.getBoundingClientRect().top - 118;
				window.scrollTo({ top: distanceToTop, left: 0, behavior: 'smooth' });
			}
		});
};
initViewMore();
